import { FC } from "react";
import FidView from "@pages/fid_view";
import { useNavigate, useParams } from "react-router-dom";
import { useGetDetailEvent } from "@hooks/useGetDetailEvent";

const ElementWrapper:FC = () => {
  const { id } = useParams<{ id: string | undefined }>()
  const navigate = useNavigate()

  if (id) {
    return <FidView id={id}/>
  }else {
    navigate("/server-error")
  }

}
export default ElementWrapper